import React, { useState } from 'react';
import { 
  Box, 
  Typography,
  Select,
  MenuItem,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Grid,
  FormControl,
  InputLabel
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import OrderBookMobile from '../OrderBookMobile';
import ButtonGroup from '@mui/material/ButtonGroup';
import RangeSlider from '../AmountRange';
import Chip from '@mui/material/Chip';

import apiClient from '../../../request/http-common';
import { setTradings } from '../../../request/Analysis/hitorySlice';

import { useMutation } from "react-query";
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Slider } from "@mui/material";

const Limit = ({orderType, balance, coinPrice}) => {
  const dispatch = useDispatch();
  const initwallet = {
    start_time : '',
    duration : '',
    stake : '', 
    stop_loss: '',
    take_profit: '',
}
  const [error, setErros] = useState('');
  const [amount, setAmount] = useState(0); 
  const [source, setSource] = useState('');
  const [coinDetails, setCoinDetails ] = useState(null);
  const tradingPlans = useSelector((state) => state.plans.tradingPlans);

  const [value, setValue] = useState([0]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setAmount((value[0]/100) * balance)
  };

  const [walletForm, setwalletForm] = useState(initwallet);
  const onChange = (e) =>
  setwalletForm({ ...walletForm, [e.target.name]: e.target.value });

  const currentPair = useSelector((state) => state.currentPair.currentPair); 

  const { isLoading: isInvesting, mutate: postInvestment } = useMutation(
    async () => {
      return await apiClient.post(`/api/start-trading`, {
        timer_units: source,
        amount: amount, 
        duration: walletForm.duration,
        stop_loss: walletForm.stop_loss,
        take_profit: walletForm.take_profit,
        trading_pair: currentPair,
        order_type: orderType,
        pair: currentPair,
        entry_point: parseFloat(coinPrice).toFixed(6)
      });
    },
    {
      onSuccess: (res) => {
          if (res.data.status === 'success') {
            dispatch(setTradings(res.data.tradings));
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            setTimeout(() => {
              // window.location.reload();
            }, 2000);
          }            
      },
      onError: (err) => {
            if (err.response?.data.length) {
              let myerror = err.response?.data || err;         
          setErros(myerror.errors)               
          }else{
              let errorMessage = err.response?.data.message || err ;
              localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
              const event = new Event('newMessage');
              window.dispatchEvent(event);
          }
      },
    }
  );

  return (
    <>
      <TextField
              fullWidth
              placeholder="Price (USDT)"
              defaultValue={coinPrice}
              size="small"
              label="Price (USDT)"
              sx={{ mb: 2 }}
            />

            <TextField
              fullWidth
              defaultValue={(((value[0]/100) * balance)/coinPrice).toFixed(4)}
              value={(((value[0]/100) * balance)/coinPrice).toFixed(4)}
              label={`Quantity (${currentPair})`}
              placeholder={`Quantity (${currentPair})`}
              size="small"
              sx={{ mb: 2 }}
            />

            <Box>
            <Box sx={{ width: '100%', marginBottom: "10px",  textAlign: "center" }}>
                {/* <Typography gutterBottom>Price Range</Typography> */}
                <Slider
                  value={value}
                  onChange={handleChange}
                  valueLabelDisplay="auto"
                  min={0}
                  max={100}
                  step={1}
                />
                <Typography>
                  Proportion: {(value[0]).toFixed(2)}%
                </Typography>

                <TextField
                  onChange={(e)=>setAmount(e.target.value)}
                  fullWidth
                  onKeyUp={(e)=>setValue([((e.target.value)/balance)* 100])}
                  type='number'
                  label="Order Value (USD)"
                  value={amount}
                  size="small"
                  sx={{ mb: 2 }}
              />
              </Box>
            </Box>

            <FormControl sx={{ mb: 4, paddingY: '2px' }} fullWidth={true}>
              <InputLabel htmlFor="time">Duration</InputLabel>
                <Select
                    onChange={(e) => setSource(e.target.value)}
                    labelId="time"
                    name="time"
                    id="time"
                     size="small"
                    label={`Duration`}
                    >
                    <MenuItem selected value=''>
                    Seconds
                    </MenuItem> 

                    {tradingPlans.length > 0 && tradingPlans.map(plan =>(
                    <MenuItem selected value={plan.id}>
                    {plan.duration}
                    </MenuItem>
                  ))}
                </Select>
                
            </FormControl>
            

            {/* Other form elements with reduced margins */}
            

            {/* Checkboxes - More compact */}
            {/* <Box sx={{display: 'flex', marginTop: '-10px', justifyContent: 'flex-start', flexDirection: 'column'}}>
              <FormControlLabel
                sx={{fontSize: '12px'}}
                control={<Checkbox size="small" />}
                label={<Typography sx={{ color: '#666' }}>TP/SL</Typography>}
              />
              <FormControlLabel
                control={<Checkbox size="small" />}
                label={<Typography sx={{ color: '#666' }}>Post-Only</Typography>}
              />
            </Box> */}

            {/* Buttons */}
            {orderType === 'Buy' ? 
            <Button onClick={postInvestment} fullWidth color='success' variant="contained" sx={{ mb: 2 }}>
            {isInvesting ? 'sending...' : 'Buy'}  
            </Button> :
            
            <Button onClick={postInvestment} fullWidth color='error' variant="contained" sx={{ mb: 2 }}>
              {isInvesting ? 'sending...' : 'Sell'}  
            </Button>
            }
            
    </>
  )
}

export default Limit
